module.exports = {"141030100":"昕水镇","141030101":"曲峨镇","141030102":"太古镇","141030200":"三多乡","141030201":"太德乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141030.json
// module id = 459
// module chunks = 0